import React, {
    Component,
    Fragment,
} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaInfoCircle from 'react-icons/lib/fa/info-circle';

import { DirectionsMap } from 'wanderu-component-directions';
import {
    Modal,
    Lightbox,
    LoadingDots,
    MarkdownContent,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './Waypoint.scss';

function getNextDayArrivalTimeString(momentObj) {
    return momentObj.format('llll') /* e.g. 'Thu, Sep 8, 2018 5:59pm' or 'Lun, 8 Mar 2018 1759' */
        .replace(momentObj.format('LT'), '')
        .trim() /* e.g. '5:59pm' or '1759' */
        .replace(momentObj.format('Y'), '')
        .trim() /* e.g. '2018' */
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .trim(); /* e.g. 'Thu Sep 8' or 'Lun 8 Mar' */
}

class Waypoint extends Component {
    static propTypes = {
        stationId: PropTypes.string,
        tripInformation: PropTypes.object,
        type: PropTypes.string,
        waypointType: PropTypes.string,
    };

    static defaultProps = {
        stationId: '',
        tripInformation: {},
        type: '',
        waypointType: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            showInfoModal: false,
        };
    }

    _toggleInfoModal = () => {
        const { tripInformation } = this.props;

        if (!tripInformation.termsAndConditions) {
            return;
        }

        this.setState((oldState) => ({
            showInfoModal: !oldState.showInfoModal,
        }));
    };

    render() {
        const {
            t,
            i18nMoment,
            i18nMoney,
            city,
            displayName,
            endpoint,
            name,
            price,
            region,
            showArrivalTime,
            timestamp,
            tripId,
            nearby,
            waypointType,
            showDisplayName,
            showPrice,
            stationId,
            tripInformation,
            liveChecksInProgress,
            type,
        } = this.props;
        const {
            showInfoModal,
        } = this.state;
        const waypointClass = classNames(
            styles.station,
            styles[waypointType],
            { [styles.endpoint]: endpoint },
        );

        const showLiveCheckPrice = endpoint || showPrice;
        let priceString;
        if (price) {
            const tripCurrency = Object.keys(price)[0];
            const tripPrice = price[tripCurrency];
            priceString = i18nMoney(tripPrice, tripCurrency).format();
        }

        return (
            <div className={styles.waypoint}>
                <div className={`${styles.time} ${styles[waypointType]}`}>
                    {i18nMoment.parseZone(timestamp).format('LT')}
                </div>
                <div className={`${styles.container} ${styles[waypointType]}`}>
                    <div className={waypointClass} />
                    <div className={`${styles.line} ${styles[waypointType]}`} />
                </div>

                <div className={`${styles.location} ${styles[waypointType]}`}>
                    {`${city}, ${region}`}
                </div>
                <div className={`${styles.stationName} ${styles[waypointType]}`}>
                    <span>{name}</span>
                    {!!stationId && (
                        <DirectionsMap
                            buttonText={t('baseApp:map')}
                            className={styles.directionsLink}
                            departStationId={stationId}
                            nearby={nearby}
                            tripId={tripId}
                            type={type}
                            waypointType={waypointType}
                        />

                    )}
                </div>

                {!!stationId && (
                    <DirectionsMap
                        buttonText={t('baseApp:map')}
                        className={styles.directionsLink}
                        departStationId={stationId}
                        nearby={nearby}
                        tripId={tripId}
                        type={type}
                        waypointType={waypointType}
                        isMobileButton
                    />
                )}

                {showArrivalTime && (
                    <div className={`${styles.nextDayArrival} ${styles[waypointType]}`}>
                        {getNextDayArrivalTimeString(i18nMoment.parseZone(timestamp))}
                    </div>
                )}

                {showDisplayName && (
                    <div className={styles.carrier}>
                        <div className={styles.carrierInfo}>
                            <span className={styles.carrierName}>
                                {displayName}
                            </span>
                        </div>
                        {showLiveCheckPrice && (
                            <Fragment>
                                {!!Object.keys(tripInformation).length && (
                                    <FaInfoCircle
                                        className={styles.info}
                                        onClick={this._toggleInfoModal}
                                    />
                                )}
                                {showInfoModal && (
                                    <Modal>
                                        <Lightbox
                                            className={styles.lightboxContainer}
                                            innerClassName={styles.infoModalContainer}
                                            onHide={this._toggleInfoModal}
                                        >
                                            <div className={styles.title}>
                                                {tripInformation.fareTitle}
                                            </div>
                                            <MarkdownContent className={styles.body}>
                                                {tripInformation.termsAndConditions}
                                            </MarkdownContent>
                                        </Lightbox>
                                    </Modal>
                                )}
                                {liveChecksInProgress
                                    ? (
                                        <LoadingDots
                                            className={styles.loadingDotsContainer}
                                            dotClassName={styles.loadingDots}
                                        />
                                    )
                                    : (
                                        <span className={styles.carrierPrice}>
                                            {priceString}
                                        </span>
                                    )}
                            </Fragment>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export {
    Waypoint,
};
export default localize(Waypoint);
